export default "__VITE_ASSET__DITvnt_I__"